// Resolve the backend base URL at runtime.
//
// Why this exists:
// `REACT_APP_BACKEND_URL` is platform-managed and may contain the PREVIEW
// staging hostname. If we use it verbatim on production (healthwrx.in), the
// browser fetches a different origin → cookies don't apply and login breaks.
//
// Strategy:
// - If the page is served from `healthwrx.in` (or any non-emergent prod host),
//   always use a relative URL (the K8s ingress routes /api/* correctly).
// - Only in preview/development do we use the env var if present.
//
// All API calls in the app should import this and use:
//   `${API_BASE}/api/...`

export const API_BASE = (() => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  const host = window.location.hostname;
  // Production domains for this app — extend if you add more
  const PROD_HOSTS = ['healthwrx.in', 'www.healthwrx.in'];
  if (PROD_HOSTS.includes(host)) return '';
  return process.env.REACT_APP_BACKEND_URL || '';
})();

export default API_BASE;
